import { match, uniqueSerialNumber } from 'components/common/form/formValidationRules';
import { fiftyCharactersMax } from 'helpers/regex';

const Kanji_Hiragana_Katakana_Regex =
  /^[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}ー・]+$/u;
const Kanji_Hiragana_Katakana_Four_Roman_Regex =
  /^[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}0-9\-ー・\s]+(?=(?:[^A-Za-z]*[A-Za-z]){0,4}[^A-Za-z]*$)/u;
const Kanji_Katakana_Regex = /^[\p{Script=Han}\p{Script=Katakana}ー・]+$/u;
const Half_Width_Katakana_Regex = /^[\uFF65-\uFF9F]+$/u;
const My_Number_Regex = /^T\d{13}$/;
const postalCodeRegex = /^[0-9]{3}-[0-9]{4}$/;

const JP = {
  forceSingleAddress: true,
  market: 'JP',
  enrollment: {
    form: {
      sections: {
        account: {
          fields: [
            'NAME_LAST',
            'NAME_FIRST',
            // 'NICKNAME',
            'ROMAN_CHARACTER_NAME',
            'COMPANY',
            'EMAIL',
            'PASSWORD',
          ],
        },
        shipping: {
          fields: ['ZIP', 'STATE', 'CITY', 'COUNTY', 'ADDRESS1', 'ADDRESS2'],
          googleAutoComplete: {
            language: 'ja',
            options: {
              types: ['geocode'],
              componentRestrictions: {
                country: 'jp',
              },
            },
          },
        },
        misc: {
          fields: ['JAPAN_SERIAL_NUMBER', 'GAIYOSHOMEN'],
          order: 2,
          localeEntry: 7,
        },
        terms: {
          fields: ['AGE', 'TERMS'],
          localeEntry: 6,
        },
        bank: {
          fields: ['jp-bank-info', 'BANK_ACCOUNT'],
          order: 4,
          localeEntry: 3,
        },
        tax: {
          fields: ['MY_NUMBER'],
          order: 3,
          localeEntry: 4,
        },
      },
    },
  },
  inputs: {
    MY_NUMBER: {
      required: false,
      mask: 'T9999999999999',
      labelRef: 'MY_NUMBER',
      validationChecks: [match(My_Number_Regex, 'validation-my-number')],
    },
    COMPANY: {
      required: false,
      validationChecks: [match(Kanji_Katakana_Regex, 'validation-kanji-katakana-only')],
    },
    NAME_ON_BANK: {
      validationChecks: [match(Half_Width_Katakana_Regex, 'validation-half-width-katakana-only')],
      labelRef: 'BANK_ACCOUNT_NAME',
    },
    NAME_BANK: {
      validationChecks: [match(Half_Width_Katakana_Regex, 'validation-half-width-katakana-only')],
    },
    NAME_BRANCH: {
      validationChecks: [match(Half_Width_Katakana_Regex, 'validation-half-width-katakana-only')],
    },
    BANK_ACCOUNT: {
      mask: '9999999',
    },
    NAME_FIRST: {
      validationChecks: [
        match(Kanji_Hiragana_Katakana_Regex, 'validation-kanji-hiragana-katakana-only'),
      ],
    },
    NAME_LAST: {
      validationChecks: [
        match(Kanji_Hiragana_Katakana_Regex, 'validation-kanji-hiragana-katakana-only'),
      ],
    },
    AGE: {
      labelRef: 'AGE_20',
    },
    ZIP: {
      labelRef: 'POSTAL_CODE',
      type: 'google-autocomplete',
      validationChecks: [match(postalCodeRegex, 'validation-postal-code')],
    },
    STATE: {
      labelRef: 'PREFECTURE',
      type: 'dropdown',
    },
    CITY: {
      labelRef: 'MUNICIPALITY',
      validationChecks: [
        match(Kanji_Hiragana_Katakana_Four_Roman_Regex, 'validation-japanese-only'),
      ],
    },
    COUNTY: {
      labelRef: 'DISTRICT',
      validationChecks: [
        match(Kanji_Hiragana_Katakana_Four_Roman_Regex, 'validation-japanese-only'),
      ],
    },
    ADDRESS1: {
      labelRef: 'Street Name and Number',
      validationChecks: [
        match(Kanji_Hiragana_Katakana_Four_Roman_Regex, 'validation-japanese-only'),
      ],
    },
    ADDRESS2: {
      labelRef: 'Apartment No. + Room No. (Japan)',
      validationChecks: [
        match(Kanji_Hiragana_Katakana_Four_Roman_Regex, 'validation-japanese-only'),
        match(fiftyCharactersMax, 'validation-max-50'),
      ],
    },
    JAPAN_SERIAL_NUMBER: {
      labelRef: 'JAPAN_SERIAL_NUMBER',
      onBlur: uniqueSerialNumber,
      requiresAsyncValidation: true,
    },
  },
};
export default JP;
